import React, { useRef, useState } from "react";
import { Button, Modal } from "@axum/ax-design";

export interface ConfirmRequest {
  title: string;
  description: React.ReactNode;
  confirmLabel: string;
  tone: "danger" | "warning";
  run: () => Promise<unknown>;
}

export const useConfirm = () => {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<ConfirmRequest | null>(null);
  const [busy, setBusy] = useState(false);
  const back = useRef<HTMLButtonElement>(null);

  const confirm = (next: ConfirmRequest) => {
    setRequest(next);
    setOpen(true);
  };

  const close = () => {
    if (!busy) setOpen(false);
  };

  const accept = () => {
    if (!request) return;
    setBusy(true);
    request.run().then(() => {
      setBusy(false);
      setOpen(false);
    });
  };

  const confirmDialog = (
    <Modal
      open={open}
      onClose={close}
      title={request ? request.title : ""}
      size="sm"
      centered
      backdrop={busy ? "static" : true}
      keyboard={!busy}
      initialFocus={back}
      footer={
        <>
          <Button ref={back} disabled={busy} onClick={close}>Volver</Button>
          <Button variant={request ? request.tone : "danger"} busy={busy} onClick={accept}>
            {request ? request.confirmLabel : ""}
          </Button>
        </>
      }
    >
      <p className="ax-mb-0">{request ? request.description : null}</p>
    </Modal>
  );

  return { confirm, confirmDialog };
};
